/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { useThree } from '@react-three/fiber';

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialInnerWall, MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../../../CustomMaterial';

const WallModel = () => {    
    const { gl } = useThree ();

    const wallThickness = 0.005;
    const offsetWithDoorThickness = 0.127;
    const cbFrontBackWallOffset = 0.16;

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false

    const texture = useMemo(() => {
        if(const_var.metalTexture){
            let texture = const_var.metalTexture.clone();
            textureAnisotropy(gl, texture,1.3, 1.3, (params.p_v_w != true) ? 0 :  Math.PI/-2);    
            return texture
        }else{
            return null
        }
    }, [params.p_v_w,params.wallTexture,const_var.wallTextureObj[params.wallTexture]])

    // const dutchDelModelBack = useMemo(() => {
    //     const freeSpace = 1;
    //     let cornerFreeSpaceW = (params.leanF_p_w - freeSpace) / 6;
    //     const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.leanF_p_h - ((params.b_l_t_r_pF / 12) * params.leanF_p_w) :  params.leanF_p_h
    //     let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
    //     if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

    //     if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
    //     if (params.add_front_lean && (params.p_b_c_b_f_b === "Half Dutch End" || params.p_b_c_b_f_b === "Half End")) {
    //         const model = new THREE.Shape();
    //         model.moveTo(-(params.leanF_p_w / 2 - freeSpace), 0);

    //         if (params.p_b_c_b_f_b === "Half Dutch End") {
    //             model.lineTo(-(params.leanF_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
    //             model.lineTo(-(params.leanF_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
    //             model.lineTo((params.leanF_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
    //             model.lineTo((params.leanF_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
    //         } else {
    //             model.lineTo(-(params.leanF_p_w / 2 - freeSpace), leftHeight - freeSpace);
    //             model.lineTo((params.leanF_p_w / 2 - freeSpace), leftHeight - freeSpace);
    //         }
    //         model.lineTo((params.leanF_p_w / 2 - freeSpace), 0);

    //         return model;
    //     } else {
    //         return []
    //     }
    // }, [params.add_front_lean, params.leanF_p_w, params.leanF_p_h, params.p_b_c_b_f_b])
    
    // Back Wall - CSG
     const backWallModelObj = useMemo(() => {
        let outerModel;
        let innerModel;
        let wainscotModel;
        
        //************************* */ inner wall geometry
        const backWallModel = new THREE.Shape();
        if (params.p_r_s === 1) {
            backWallModel.moveTo(-(params.leanF_p_w), 0);
            backWallModel.lineTo(-(params.leanF_p_w), params.leanF_p_h);
            backWallModel.lineTo(-(params.leanF_p_w), params.leanF_p_h + const_var.roofRegularDst);
            backWallModel.quadraticCurveTo(-(params.leanF_p_w), params.leanF_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pF / 12) / 10, 
                                            -(params.leanF_p_w - const_var.roofRegularDst + 0.1), params.leanF_p_h + const_var.roofRegularDst * (2 + params.b_l_t_r_pF / 12))
            backWallModel.lineTo(-cbFrontBackWallOffset, params.leanF_p_h + ((params.b_l_t_r_pF / 12) * (params.leanF_p_w) + const_var.roofRegularDst * (2)));
            backWallModel.lineTo(-cbFrontBackWallOffset, 0);
            backWallModel.closePath();
        } else {
            backWallModel.moveTo(-params.leanF_p_w + offsetWithDoorThickness - 0.12, params.leanF_p_h);
            backWallModel.lineTo(-cbFrontBackWallOffset, params.leanF_p_h + params.leanF_p_w / 12 * params.b_l_t_r_pF);
            backWallModel.lineTo(-cbFrontBackWallOffset, 0);
            backWallModel.lineTo(-params.leanF_p_w + offsetWithDoorThickness - 0.12, 0);
            backWallModel.closePath();
        }

         const meshBackWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallModel, extrudeSettings(0.005)), new THREE.MeshStandardMaterial({ color: 'brown' }))
         const meshBackDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanStorageBack', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
         const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        //  const meshDutchDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(dutchDelModelBack, extrudeSettings(1)), new THREE.MeshStandardMaterial({color: 'blue'}))

         let meshBackWallModel_Temp = meshBackWallModel.clone();
         meshBackWallModel_Temp.rotateY(Math.PI / 2);
         meshBackWallModel_Temp.position.set(-params.leanF_p_d / 2 + 0.02, 0, params.p_d / 2);
         meshBackWallModel_Temp.updateMatrixWorld();
     
         let meshBackDelModel_Temp = meshBackDelModel.clone();
         meshBackDelModel_Temp.rotateY(Math.PI / 2);
         meshBackDelModel_Temp.position.set(-params.leanF_p_d / 2 - 0.5, 0, 0);
         meshBackDelModel_Temp.updateMatrixWorld();

         let meshSideDelModel_Temp = meshSideDelModel.clone();
         meshSideDelModel_Temp.position.set(-params.leanF_p_pos - params.frontLeanStoragePosition, 0, params.p_d / 2 + params.leanF_p_w - 0.05);
         meshSideDelModel_Temp.updateMatrixWorld();

        //  let meshDutchDelModel_Temp = meshDutchDelModel.clone();
        //  meshDutchDelModel_Temp.rotateY(Math.PI / 2);
        //  meshDutchDelModel_Temp.position.set(- params.leanF_p_d / 2 - 0.5,0, params.p_d / 2 + params.leanF_p_w / 2);
        //  meshDutchDelModel_Temp.updateMatrixWorld();
     
         const meshBackWallModel_CSG = CSG.fromMesh(meshBackWallModel_Temp);
         const meshBackDelModel_CSG = CSG.fromMesh(meshBackDelModel_Temp);
         const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
        //  const meshDutchDelModel_CSG = CSG.fromMesh(meshDutchDelModel_Temp);
     
         const backWallModel_CSG = meshBackWallModel_CSG.subtract(meshBackDelModel_CSG);
         const meshSideInnerDelModel_CSG = backWallModel_CSG.subtract(meshSideDelModel_CSG);
        //  const meshBackInnerModel_CSG = meshSideInnerDelModel_CSG.subtract(meshDutchDelModel_CSG);

         const CSGBackWallModel = CSG.toMesh(
            meshSideInnerDelModel_CSG,
             new THREE.Matrix4(),
             new THREE.MeshStandardMaterial({ color: 'blue' })
         )

        innerModel = CSGBackWallModel.geometry;

        //************************* */ outer wall geometry
        let verticalHorizontalPosB = {"x": params.leanF_p_d /-2 - 0.0025,"y" : (params.p_w_c_n ? 2.935 : 0), "z" : params.p_d / 2}
        let verticalHorizontalRotB = {"x":0,"y" : 0,"z" : Math.PI / 2}
        const patternLengthB = params.leanF_p_h + ((params.b_l_t_r_pF / 12) * (params.leanF_p_w)) + (params.p_r_s === 1 ? 3 : 0);
        const patternDepthB = params.leanF_p_w

        // let wallpanelValue = (params.p_r_s === 1) ?  0.1 : 0
        // const backWallCutModel = new THREE.Shape();
        // backWallCutModel.moveTo((params.p_d / 2), params.leanF_p_h + ((params.b_l_t_r_pF / 12) * (params.leanF_p_w))); //right lean left top
        // backWallCutModel.lineTo((params.p_d / 2 + params.leanF_p_w + 0.15), params.leanF_p_h); //right lean right top
        // backWallCutModel.lineTo((params.p_d / 2 + params.leanF_p_w + 0.15), wallpanelValue); //right lean right bottom
        // backWallCutModel.lineTo((params.p_d / 2), wallpanelValue); //right lean left bottom
        // backWallCutModel.closePath();

         const meshWallModelB = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthB, isPattern), extrudeSettings(patternDepthB)))  
        //  const meshGableDelModelB = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallCutModel, extrudeSettings(1)))
        const meshGableDelModelB = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallModel, extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'brown' }))
     
         let meshGableDelModel_TempB = meshGableDelModelB.clone();
        meshGableDelModel_TempB.rotateY(Math.PI / 2);
        meshGableDelModel_TempB.position.set(-params.leanF_p_d / 2 - 0.5, 0, params.p_d / 2)
         meshGableDelModel_TempB.updateMatrixWorld();
     
         let meshWallModel_TempB = meshWallModelB.clone();
         meshWallModel_TempB.position.set(verticalHorizontalPosB.x,verticalHorizontalPosB.y,verticalHorizontalPosB.z + 0.15);
         meshWallModel_TempB.rotation.set(verticalHorizontalRotB.x,verticalHorizontalRotB.y,verticalHorizontalRotB.z);
         meshWallModel_TempB.updateMatrixWorld();

         let meshSideOuterDelModel_Temp = meshSideDelModel.clone();
         meshSideOuterDelModel_Temp.position.set(-params.leanF_p_pos - params.frontLeanStoragePosition, 0, params.p_d / 2 + params.leanF_p_w - 0.2);
         meshSideOuterDelModel_Temp.updateMatrixWorld();
     
         const meshWallModel_CSGB = CSG.fromMesh(meshWallModel_TempB);
         const meshGableDelModel_CSGB = CSG.fromMesh(meshGableDelModel_TempB);
         const meshSideOuterDelModel_CSG = CSG.fromMesh(meshSideOuterDelModel_Temp);
         
     
         const wallModel_CSGB = meshWallModel_CSGB.subtract(meshBackDelModel_CSG);
         const GableModel_CSGB = wallModel_CSGB.intersect(meshGableDelModel_CSGB);
         const SideOuterDelModel_CSG = GableModel_CSGB.subtract(meshSideOuterDelModel_CSG);
        //  const MeshFrontOuterModel_CSG = SideOuterDelModel_CSG.subtract(meshDutchDelModel_CSG);
     
         const CSGWallModelB = CSG.toMesh(SideOuterDelModel_CSG,new THREE.Matrix4())

         outerModel = CSGWallModelB.geometry;

        //************************* */ outer wall geometry
        let wainscotVerticalHorizontalPosB = {"x": params.leanF_p_d /-2 - 0.0025,"y" : 0, "z" : params.p_d / 2}
        let wainscotVerticalHorizontalRotB = {"x":0,"y" : 0,"z" : Math.PI / 2}
        const lengthPatternB = 3;
        const depthPatternB = patternDepthB;

        const meshBackWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternB, isPattern), extrudeSettings(depthPatternB)))
        let meshBackWainscotModel_Temp = meshBackWainscotModel.clone();
        meshBackWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosB.x,wainscotVerticalHorizontalPosB.y,wainscotVerticalHorizontalPosB.z + 0.15);
        meshBackWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotB.x,wainscotVerticalHorizontalRotB.y,wainscotVerticalHorizontalRotB.z);
        meshBackWainscotModel_Temp.updateMatrixWorld();
    
        const meshBackWainscotModel_CSG = CSG.fromMesh(meshBackWainscotModel_Temp);
    
        const backWainscotModel_CSG = meshBackWainscotModel_CSG.subtract(meshBackDelModel_CSG);
        const sideDelWainscotModel_CSG = backWainscotModel_CSG.subtract(meshSideOuterDelModel_CSG);
        // const finalFrontwainscotModel_CSG = sideDelWainscotModel_CSG.subtract(meshDutchDelModel_CSG);

        const CSGBackWainscotModel = CSG.toMesh(
            sideDelWainscotModel_CSG,
            new THREE.Matrix4()
            )

        wainscotModel = CSGBackWainscotModel.geometry;

        return {outerModel, innerModel, wainscotModel}

     }, [params.wallTexture,params.p_w, params.p_d, params.p_h, params.frontLeanStoragePosition, params.p_r_p, params.p_r_s, params.leanF_p_w, params.leanF_p_d, params.leanF_p_h, params.b_l_t_r_pF, params.p_b_c_b_f_b, params.p_v_w, const_var.newDoorsArray, params.leanF_p_pos, params.p_w_c_n]);   
     

    return (
        <>
            {backWallModelObj?.outerModel &&
                <mesh name="F_L_L_S_W" geometry={backWallModelObj?.outerModel}>
                    <MaterialOuterWallNew isPattern={isPattern}     visibleSection={"frontLean"} />
                </mesh>
            }
            {
                backWallModelObj && backWallModelObj?.innerModel && <mesh name="back" geometry={backWallModelObj?.innerModel} position={[wallThickness + 0.01, 0, 0]} >
                    <MaterialInnerWall texture={texture} visibleSection={"frontLean"} />
                </mesh>
            }
             {/* Back Wainscot */} 
             {params.p_w_c_n === true && backWallModelObj?.wainscotModel &&
                <mesh name="F_L_L_S_W_wainscot" geometry={backWallModelObj?.wainscotModel} >
                    <MaterialWainScotWallNew isPattern={isPattern}     visibleSection={"frontLean"} />
                </mesh>
            }
        </>
    )
}

export default WallModel